import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { postSession } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) {
        navigate("/admin/login");
        return;
      }
      try {
        await postSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin");
      } catch (e) {
        const msg = e?.response?.data?.detail || "Login failed. Please try again.";
        navigate("/admin/login", { state: { error: msg } });
      }
    })();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] text-white">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-teal border-t-transparent" />
        <p className="font-condensed text-xl tracking-widest text-zinc-400">SIGNING YOU IN…</p>
      </div>
    </div>
  );
}
